export const usage = {
  title: "Detalles de Uso",
  subtitle: "Controlá tu uso de tokens y costos",
  table: {
    date: "Fecha",
    model: "Modelo",
    promptTokens: "Tokens de Entrada",
    completionTokens: "Tokens de Salida",
    inputCost: "Costo de Entrada",
    outputCost: "Costo de Salida",
    totalCost: "Costo Total",
  },
  stats: {
    subscription: {
      plan: "Plan",
      credits: "Créditos Disponibles",
      totalSpent: "Total Gastado",
      status: "Estado", // More common than "Status"
      nextBilling: "Próxima Facturación", // More natural than "Cobrança"
    },
    total: {
      title: "Uso Total",
      tokens: "Total de Tokens",
      cost: "Costo Total",
    },
    byModel: {
      title: "Uso por Modelo",
      model: "Modelo",
      inputTokens: "Tokens de Entrada",
      outputTokens: "Tokens de Salida",
      inputCost: "Costo de Entrada",
      outputCost: "Costo de Salida",
      totalCost: "Costo Total",
      inputOutputTokens: "Tokens de Entrada / Salida", // More natural phrasing
    },
    recent: {
      title: "Uso Reciente",
      noTransactions: "No hay transacciones recientes",
    },
  },
  noData: "No hay datos de uso disponibles",
  loading: "Cargando datos de uso...",
  error: "Error al cargar los datos de uso",
  refresh: "Actualizar Datos",
};
